/**
 * Reporting Platform theme — uses shared Selerity theme from @selerity/ui.
 */
import { selerityTheme } from "@selerity/ui";

export const theme = selerityTheme;
